export default "__VITE_ASSET__CJhBJE1l__"